import { MutableRefObject } from "react";

import { CommonListProps } from "@/common/types/ListFromApi.types";
import { IMeta } from "@/core/libs/api/interfaces/meta.interface";
import { IMessageBar } from "@/core/libs/message-bar";

export type DistributionCenterProps = {
  canCreate: boolean;
  canEdit: boolean;
};

export type DistributionCenterItem = {
  name: string;
  type: DistributionCenterType;
  city?: string;
  code?: string;
  id?: string;
  latitude?: string;
  longitude?: string;
  neighborhood?: string;
  note?: string;
  number?: string;
  state?: string;
  street?: string;
  zipCode?: string;
  businessUnit?: { id: number };
  businessUnits?: { id: number }[];
};
export interface ListOfDistributionCenters extends CommonListProps {
  items?: DistributionCenterItem[];
  meta: IMeta;
}

export type CreateProps = {
  create: (values, { setSubmitting, isAdmin }, closeDrawer) => void;
  dismissMessage: () => void;
  closeDrawer: () => void;
  drawerContainerRef: MutableRefObject<HTMLDivElement>;
  message: IMessageBar;
};

export type EditProps = {
  edit: (values, { setSubmitting, isAdmin }, closeDrawer) => void;
  dismissMessage: () => void;
  closeDrawer: () => void;
  drawerContainerRef: MutableRefObject<HTMLDivElement>;
  message: IMessageBar;
  selectedItemId: string;
};

export enum DistributionCenterType {
  DISTRIBUTION_CENTER = "DISTRIBUTION_CENTER",
  SERVICE_POINT = "SERVICE_POINT",
  MOBILE = "MOBILE"
}

export enum DistributionCenterTypeTranslate {
  DISTRIBUTION_CENTER = "Armazém",
  SERVICE_POINT = "Ponto de Atendimento",
  MOBILE = "Móvel"
}
